export const ALERT_STATUS = {
  ALERT: "alert",
  ACKNOWLEDGED: "acknowledged",
  INFO: "info",
};

export const ALERT_OPERATOR_LABELS = {
  up: "이상",
  down: "이하",
  equal: "일치",
};
